module.exports = __webpack_public_path__ + "static/img/3.e7db7c6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/3/sp/3.png
// module id = Vxtv
// module chunks = 0